import {Component, OnInit} from '@angular/core';
import {IOption} from "ng-select";
import {BsModalRef} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";
import { API_URL } from '../config';

@Component({
  selector: 'app-print-preview-permit-to-work-alkhorayef',
  templateUrl: './print-preview-permit-to-work-alkhorayef.component.html',
  styleUrls: ['./print-preview-permit-to-work-alkhorayef.component.scss'],
  providers: [RilrService]
})
export class PrintPreviewPermitToWorkAlkhorayefComponent implements OnInit {

  public masterData: any = {};
  public templateData: any = {};
  public accidentScatArr: any = [];
  public incidentColspan: number = 0;
  reportSystemID: number;
  documentSystemID: number;

  documentTypeLabel: string = "incident report";

  public incidentTypeArr: Array<IOption> = [];

  companySystemID = +this.helperService.getSelectedCompanyId();

  incidentCategoryArr: any[];
  incidentSubCategoryArr: any[];
  incidentSubCategoryDynamicArr: any[];
  correctiveactionstbl: any = [];

  public documentData: any = {};
  public reportCheckListCategory: any = {};
  checklistColumnsArr: any[];
  public reportCheckList: any = [];

  constructor(public bsModalRef: BsModalRef,
              private helperService: HelperService,
              private spinner: NgxSpinnerService,
              private rilrService: RilrService) {
  }

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.reportPrintPreview();
      this.templateAssignedRoute("Print");
    }, 0);

  }

  public templateAssignedRoute(crudType) {
    const that = this;
    that.rilrService
      .getTemplateAssignedRoute()
      .get({
        crudType: crudType,
        documentSystemID: that.documentSystemID,
        companySystemID: that.helperService.getSelectedCompanyId()
      })
      .subscribe(
        (output) => {
          const resp = output.data.data;
          that.templateData = resp;
        },
        () => {}
      );
  }

  reportPrintPreview() {
    const that = this;
    that.rilrService
      .reportPrintPreviewData()
      .get({
        companySystemID: that.companySystemID,
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID
      })
      .subscribe(data => {
        const resp = data.data.data;
        that.incidentTypeArr = that.helperService.incidentsIdChangeToInt(resp.incidents);
        that.incidentCategoryArr = resp.incidentCategory;
        that.incidentSubCategoryArr = resp.IncidentSubCategory;
        that.incidentColspan = that.incidentTypeArr.length;
        that.masterData = resp.reportData;
        that.incidentSubCategoryDynamicArr = resp.incidentDynamicSubCategory;
        that.correctiveactionstbl = resp.actions;
        that.documentTypeLabel = resp.document.documentDescription;
        that.accidentScatArr = resp.accidentScat;
        that.documentData = resp.document;
        that.checklistColumnsArr = resp.headerColumns;
        that.reportCheckListCategory = resp.reportCheckListCategory;
        that.reportCheckList = resp.reportCheckList;
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  print_pdf_preview() {
    this.rilrService
      .printPermitToWorkPDF()
      .get({
        id: this.reportSystemID,
        documentSystemID: this.documentSystemID,
        companySystemID: this.companySystemID
      })
      .subscribe(resp => {
        const data = resp.data.data;

        const link = document.createElement('a');
        link.target = '_blank';
        link.href = API_URL+'/'+data.pdf_path;
        link.setAttribute('visibility', 'hidden');
        link.click();
       // window.open(data.pdf_path, "_blank");
      }, (error) => {
        if (error.status == 500) {
          //this.tosterMessageService.showError("Error", error.data.message);
        }
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/print-preview-permit-to-work-alkhorayef/print-preview-permit-to-work-alkhorayef.component.ts